// extracted by mini-css-extract-plugin
module.exports = {"ToastPopup":"_3G_VSZrYat69lL8Kyeyo0F"};